<template>
    <section class="kvArea">
        <h1 class="KvTitle" title="MSI" v-html="kvData.banner_content"></h1>
        <figure class="kvArea__imgBox">
            <img
                class="kvImg"
                :src="kvData.banner_image"
                :alt="kvData.banner_title"
            />
        </figure>
    </section>
</template>

<script>
export default {
    name: "Kv",
    props: {
        kvData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
};
</script>

<style lang="sass" scoped>
.kvArea
	position: relative
	margin-bottom: 20px
	&__imgBox
		.kvImg
			width: 100%
			vertical-align: middle
			opacity: 0.8

	.KvTitle
		height: 70px
		text-align: center
		position: absolute
		top: 0
		bottom: 0
		right: 0
		left: 0
		z-index: 10
		margin: auto
		font-size: 25px
</style>
